import React, { useState, useEffect } from "react";
import { Button, Dialog } from "@mui/material";
import useMediaQuery from '@mui/material/useMediaQuery';

import ButtonGroupCustom from "../button_group";
import { theme, getStatus } from "../../constants/theme";
import CardOwnerInfo from "../card_info/card_owner_info";
import CardConfig from "../card_info/card_config";
import CardReport from "../card_info/card_report";

const CardInfoEditDialog = ({ selectedCard = {}, open = false, toggle, onSuccess }) => {
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [selectedTab, setSelectedTab] = useState(0)

  const [cardOwnerInfo, setCardOwnerInfo] = useState({})
  const [cardConfig, setCardConfig] = useState({})

  useEffect(() => {
    setCardOwnerInfo({
      name: selectedCard.driver ?? '',
      phone: selectedCard.phone ?? '',
      plate: selectedCard.carPlate ?? ''
    })
    setCardConfig({
      locked: selectedCard.lockedItem ?? '',
      status: selectedCard.status,
    })
  }, [selectedCard])

  useEffect(() => {
    if (!open) {
      setSelectedTab(0)
      setCardOwnerInfo({})
      setCardConfig({})
    }
  }, [open])

  const onCancel = (e, reason) => {
    if (reason && reason === "backdropClick") return;
    toggle(false);
  };

  const onSubmit = () => {
    if (onSuccess != null) onSuccess()
    toggle(false);
  };

  return (
    <Dialog 
      maxWidth={'lg'}
      fullScreen={fullScreen ?? false} 
      open={open} onClose={onCancel}
    >
      <div className="d-flex d-sm-none dialog-header">
        <div className="font-size-16 font-weight-bold">Картын мэдээлэл</div>
        <button className="fab-btn" onClick={() => toggle(false)}>
          <img alt="close" src="/images/close.svg" height={11} />
        </button>
      </div>
      <div className="buttom-group-container dialog-header border-none">
        <div className="ps-0 ps-sm-3 w-100 w-sm-auto">
          <ButtonGroupCustom 
            active={selectedTab}
            setActive={setSelectedTab}
            items={['Карт Эзэмшигч', 'Картын Тохиргоо', 'Тайлан']}
          />
        </div>
        <button className="fab-btn d-none d-sm-block" onClick={() => toggle(false)}>
          <img alt="close" src="/images/close.svg" height={11} />
        </button>
      </div>
      <div className="dialog-sub-header align-items-start flex-wrap pt-0">
        <div className="ps-2 ps-sm-4 font-weight-500 w-50 w-md-auto mt-1">
          <div className="text-grey font-size-12">КАРТЫН ДУГААР</div>
          <div className="font-size-16">{selectedCard.cardNumber ?? ''}</div>
        </div>
        <div className="ps-2 ps-sm-4 font-weight-500 w-50 w-md-auto mt-1">
          <div className="text-grey font-size-12">ЖОЛООЧ</div>
          <div className="font-size-16">{selectedCard.driver ?? ''}</div>
        </div>
        <div className="ps-2 ps-sm-4 font-weight-500 w-50 w-md-auto mt-1">
          <div className="text-grey font-size-12">МАШИНЫ ДУГААР</div>
          <div className="font-size-16">{selectedCard.carPlate ?? ''}</div>
        </div>
        <div className="flex-grow-1 font-size-14 text-grey w-50 w-md-auto mt-1 align-self-end text-start text-md-end">
          {getStatus(selectedCard.status === 'active')}
        </div>
      </div>
      <div className="dialog-body px-4 px-sm-5 py-3">
        {
          selectedTab === 0 ? <CardOwnerInfo 
            cardOwnerInfo={cardOwnerInfo} 
            setCardOwnerInfo={setCardOwnerInfo}
          /> : selectedTab === 1 ? <CardConfig 
            cardConfig={cardConfig}
            setCardConfig={setCardConfig}
          /> : <CardReport />
        }
      </div>
      <div className="dialog-footer">
        <Button
          onClick={onCancel}
          className="btn-bordered btn-bordered-grey mx-3"
          variant="contained"
          disableElevation
        >
          <span className="mx-2">Цуцлах</span>
        </Button>
        <Button
          onClick={onSubmit}
          className="bg-primary btn-bordered"
          variant="contained"
          disableElevation
        >
          <span className="mx-2">Хадгалах</span>
        </Button>
      </div>
    </Dialog>
  );
};


export default CardInfoEditDialog;
